import React from "react"
import PropTypes from "prop-types"

const TextContent = ({children}) => (
  <div className="sh-text-content">{children}</div>
)

TextContent.propTypes = {
  children: PropTypes.node
}

export default TextContent



// WEBPACK FOOTER //
// ./src/components/decorators/TextContent.js